import React from "react";
import InPersonIcon from "./In_Person_Icon.png";
import styles from "./InPersonMeetingIcon.module.css";

/**
 * View component. Displays an icon which indicates that a meeting is in person.
 * Takes a string prop that determines the icon text color.
 */
export function InPersonMeetingIcon({}) {
  return (
    <div className={styles.container}>
      <img
        src={InPersonIcon}
        className={styles.icon}
        alt="In-person meeting icon"
      />
      <div className={styles.text}>In Person</div>
    </div>
  );
}
